import { render, staticRenderFns } from "./ios14Icon.vue?vue&type=template&id=b4b34826&"
import script from "./ios14Icon.vue?vue&type=script&lang=js&"
export * from "./ios14Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports